import { useToken } from "@dexteel/mesf-core";
import { Button, Grid } from "@material-ui/core";
import type { EditableCallbackParams } from "ag-grid-community";

type Props = EditableCallbackParams;

export const AttachmentsDownloadButtons = ({ data }: Props) => {
	const { token: bearerToken } = useToken();

	return (
		<Grid container spacing={1} style={{ alignItems: "center" }}>
			{data?.Path && (
				<Grid item md={12} xs={12}>
					<Button
						href={`/backend/files/${data?.UploadFileId}/download?Authorization=${bearerToken}`}
						target="_blank"
						rel="noopener noreferrer"
						fullWidth
						variant="outlined"
						style={{
							textDecoration: "none !important",
							fontWeight: 500,
							fontSize: "12px",
							borderRadius: "3px",
							border: "1px solid #3F51B5",
							color: "#3F51B5",
							background: "#FFFF",
						}}
						download={`${data?.FileName} `}
					>
						DOWNLOAD
					</Button>
				</Grid>
			)}
		</Grid>
	);
};
